import { getTranslatedProductCategories, ProductCategoriesLink } from "components/Navbar/types"
import { CATEGORIES } from "pages/Products/ProductPage/mock"
import {
  GlassesOptionsType,
  GlassesProduct,
  GlassesRenderingOptionsType,
  initRenderingOptions,
  ProductV2,
} from "types"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
  IGlassesRenderingOptions,
  IResponseProductsCategories,
  ProductState,
  ProductType,
  ProductTypeName,
} from "./types"
import { RootState } from "store/store"

const initialProductState: ProductV2 = {
  merchant: "",
  name: "",
  cover: "",
  upc: "",
  brand: "",
  sku: "",
  id: "",
  brandId: "",
  brandSlug: "",
  categoryId: 0,
  url: "",
  colors: [],
  coverage: "",
  finish: "",
  region: "",
  type: "",
  typeId: "",
}

type SetProductsCategoriesAction = PayloadAction<{
  categories: IResponseProductsCategories[]
  t: (key: string) => string
}>

const initialState: ProductState = {
  productsCategories: [
    {
      to: ProductCategoriesLink.MAKEUP,
      label: "Make up",
    },
  ],
  productsCategoriesLoading: false,
  product: null,
  types: [],
  glasses: {
    ...initialProductState,
    categoryId: CATEGORIES?.find((el) => el.name === ProductTypeName.Glasses)?.id || 0,
    renderingOptions: initRenderingOptions,
    coverLeft: null,
    coverFront: null,
    coverRight: null,
    framingSize: "",
    dataFilling: false,
    file: undefined,
  },
}

export const productsSlice = createSlice({
  name: "currentProduct",
  initialState,
  reducers: {
    setProductsCategories: (state, action: SetProductsCategoriesAction) => {
      state.productsCategories = action.payload.categories.map((category) => {
        const label =
          getTranslatedProductCategories(action.payload.t)[category.name] || category.name
        const to = ProductCategoriesLink[category.name] || "/products"

        return {
          label,
          to,
        }
      })
    },
    setProductsCategoriesLoading: (state, action: PayloadAction<boolean>) => {
      state.productsCategoriesLoading = action.payload
    },
    setCurrentProduct: (state, action: PayloadAction<any>) => {
      state.product = action.payload
    },
    setGlasses: (state, action: PayloadAction<any>) => {
      state.glasses = action.payload
    },
    setGlassesOptionsByKey: <K extends keyof GlassesProduct>(
      state: ProductState,
      action: PayloadAction<GlassesOptionsType<K>>
    ) => {
      const { value, key } = action.payload

      state.glasses[key] = value
    },
    setGlassesRenderingOptionsByKey: <K extends keyof IGlassesRenderingOptions>(
      state: ProductState,
      action: PayloadAction<GlassesRenderingOptionsType<K>>
    ) => {
      const { value, key } = action.payload

      state.glasses.renderingOptions[key] = value
    },
    clearGlasses: (state) => {
      state.glasses = initialState.glasses
    },
    clearProductSlice: () => {
      // TODO: clear product slice should do something
      // state = { ...initialState, product: null }
    },
    setTypes: (state, action: PayloadAction<ProductType[]>) => {
      state.types = action.payload
    },
  },
})

export const {
  setCurrentProduct,
  clearGlasses,
  setGlasses,
  setGlassesOptionsByKey,
  setGlassesRenderingOptionsByKey,
  clearProductSlice,
  setProductsCategories,
  setProductsCategoriesLoading,
  setTypes,
} = productsSlice.actions

export const selectTypes = (state: RootState) =>
  state.products.types.filter(
    (type) =>
      type.name !== "EYELASHES" &&
      (parseInt(type.id) <= 18 ||
        type.name.includes("FOUNDATION") ||
        type.name.includes("POWDER"))
  )

export default productsSlice.reducer
